import { render, staticRenderFns } from "./TrafficLight.vue?vue&type=template&id=b1dd9e04&scoped=true&"
import script from "./TrafficLight.vue?vue&type=script&lang=js&"
export * from "./TrafficLight.vue?vue&type=script&lang=js&"
import style0 from "../../public/css/trafficLight.css?vue&type=style&index=0&id=b1dd9e04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dd9e04",
  null
  
)

export default component.exports